import dataProvider, { client } from "data/hasura";
import { gAPI } from "data/gapi"

import {
    FirebaseAuth,
} from "./authProvider";

import { auth } from "./config"
import { User, getIdTokenResult } from "firebase/auth";
import gql from "graphql-tag";
import { getDefaultStore } from "jotai";
import { apiJWTAtom } from "@auth/state";
import { logger } from "@utils/logger";
import { roleAtom } from "@auth/firebase/state";
import { getRole } from "@auth/definitions";
import { IAuthRoles } from "./interfaces";

export const firebaseAuth = new FirebaseAuth({
    onCheck: async (user: User) => {
        // logger.debug("check hook", user)
        const token = await user?.getIdToken()
        // logger.debug('token:', token)
        if (!token)
            return {
                authenticated: false
            }
        client.setHeader('Authorization', `Bearer ${token}`)
        const store = getDefaultStore()
        store.set(apiJWTAtom, token)

        return {
            authenticated: true,
            // googleAuthenticated: true
        }
    },
    onAuthChange: async (user: User, auth) => {
        // TODO: implement when user disabled
    },
    onIdTokenChange: async (user: User, auth) => {
        // TODO: implement when user disabled
    },
    onLogin: async (user: User, auth) => {
        // logger.debug(user, auth)

        const token = await user.getIdToken()
        if (!token)
            return
        client.setHeader('Authorization', `Bearer ${token}`)
        // logger.debug(res)
        const store = getDefaultStore()
        store.set(roleAtom, await getRole())
    },
    onError: async (user: User, error: any, auth) => {

        logger.debug(error)
        // refresh google GAPI auth
        if (error.result?.error?.status == "UNAUTHENTICATED") {
            logger.debug('Google not authenticated')

            const res = await dataProvider.custom({
                url: '',
                method: 'post',
                meta: {
                    gqlQuery: gql`query GetToken {
                    get_access_token {
                        access_token
                    }
                  }`
                },
            })
            const accessToken = res?.data?.get_access_token?.access_token
            gAPI.client?.setToken({ access_token: accessToken })

            return {
                error
            };
        } else {
            // refresh firebase token
            const token = await user?.getIdToken()
            // logger.debug('token:', token)
            if (!token)
                return
            client.setHeader('Authorization', `Bearer ${token}`)

            return {

            }
        }
    },
    onLogout: async () => {
        client.setHeader('Authorization', '')
        gAPI.client?.setToken({ access_token: '' })
        const store = getDefaultStore()
        store.set(roleAtom, await getRole())
    },
    onIdentity: async (_: User, auth: FirebaseAuth) => {
        await auth.auth.authStateReady()

        if (!auth.auth.currentUser) {
            return
        }
        const tokenResult = await getIdTokenResult(auth.auth.currentUser);
        // logger.debug(tokenResult)

        const customClaims = tokenResult.claims['https://hasura.io/jwt/claims'] as Record<string, string>
        const user_id = customClaims['x-hasura-user-id']
        const user_uid = customClaims['x-hasura-user-uid']

        return {
            user_id,
            user_uid,
            authToken: tokenResult
        }
    },
    onPermissions: async (_: User, auth: FirebaseAuth) => {
        const store = getDefaultStore()
        return store.get(roleAtom) as IAuthRoles
    }
}, auth);

export const authProvider = firebaseAuth.getAuthProvider()
